import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {deepAssign} from '@aofl/object-utils';


const sdo = {
  namespace: sdoNs.TABS,
  mutations: {
    init(payload) {
      const defaultModuleState = {};

      if (payload) {
        // reset state of existing tab groups
        for (const groupId in payload) {
          if (!payload.hasOwnProperty(groupId)) continue;
          for (const key in payload[groupId]) {
            if (!payload[groupId].hasOwnProperty(key)) continue;
            payload[groupId][key] = false;
          }
        }
      }

      return payload || defaultModuleState;
    },

    addGroup(moduleState, {groupId, tabs}) {
      if (typeof moduleState[groupId] !== 'undefined' && moduleState[groupId] === tabs) {
        return moduleState;
      }

      return Object.assign({}, moduleState, {
        [groupId]: tabs
      });
    },

    unselect(moduleState, {groupId, tabId}) {
      return deepAssign(moduleState, `${groupId}`, {
        [tabId]: false
      });
    },

    unselectAll(moduleState, groupId) {
      const tabGroup = Object.assign({}, moduleState[groupId]);
      for (const key in tabGroup) {
        if (!tabGroup.hasOwnProperty(key)) continue;
        tabGroup[key] = false;
      }

      return deepAssign(moduleState, `${groupId}`, tabGroup);
    },

    select(moduleState, {groupId, tabId}) {
      if (typeof moduleState[groupId] === 'undefined' || typeof moduleState[groupId][tabId] === 'undefined') {
        return moduleState;
      }
      const nextModuleState = sdo.mutations.unselectAll(moduleState, groupId);
      return deepAssign(nextModuleState, `${groupId}`, {
        [tabId]: true
      });
    }
  },
  decorators: [
    (_nextState) => {
      const state = storeInstance.getState();
      let nextState = _nextState;

      for (const groupKey in nextState[sdoNs.TABS]) {
        if (!nextState[sdoNs.TABS].hasOwnProperty(groupKey) ||
        (state[sdoNs.TABS][groupKey] === nextState[sdoNs.TABS][groupKey] && typeof nextState[sdoNs.TABS][groupKey].$selected !== 'undefined')) continue;

        for (const key in nextState[sdoNs.TABS][groupKey]) {
          if (!nextState[sdoNs.TABS][groupKey].hasOwnProperty(key) || groupKey === '$selected') continue;

          if (nextState[sdoNs.TABS][groupKey][key] === true) {
            nextState = deepAssign(nextState, `${sdoNs.TABS}.${groupKey}`, {
              $selected: key
            });
            break;
          }
        }
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
